import {
  BaseAPI,
  OnRequestChangeCallback,
  Request,
} from '../BaseAPI'

export const baseAddress: string =
  import.meta.env.VITE_API_BASE_URL || 'https://localhost:44367'

export type HttpGetMetaData<T> = {
  page?: number
  pageSize?: number
  search?: string
  orderBy?: keyof T
  totalCount?: number
  orderDirection?: 'desc' | 'asc'
}
export abstract class InternalAPI extends BaseAPI {
  /**
   *
   * @param relativePath - relative path to the API /api/...
   */
  constructor(
    relativePath?: string,
    onRequestChanged?: OnRequestChangeCallback
  ) {
    super(baseAddress, onRequestChanged)
    this.relativePath = relativePath ?? '/'
  }

  private async ensureAuthenticated() {
    const headers = await this.withAuthHeader()
    if (!headers.Authorization) {
      throw { message: 'Authentication token not available', status: 401 }
    }
  }

  protected async PostAuthenticatedAsync<T>(request: Request) {
    await this.ensureAuthenticated()
    return this.PostAsync<T>(request)
  }

  protected async PutAuthenticatedAsync<T>(request: Request) {
    await this.ensureAuthenticated()
    return this.PutAsync<T>(request)
  }

  protected async DeleteAuthenticatedAsync(request: Request) {
    await this.ensureAuthenticated()
    return this.DeleteAsync(request)
  }
}
